import React from 'react';
import { ArrowUpRightIcon, ArrowDownRightIcon } from 'lucide-react';
const loData = [{
  id: 1,
  name: 'Sarah Jenkins',
  tier: 'A',
  funded: '$3.2M',
  goal: '110%',
  pipeline: '$4.5M',
  calls: 52,
  status: 'healthy'
}, {
  id: 2,
  name: 'Michael Chen',
  tier: 'A',
  funded: '$2.8M',
  goal: '105%',
  pipeline: '$3.8M',
  calls: 48,
  status: 'healthy'
}, {
  id: 3,
  name: 'David Miller',
  tier: 'B',
  funded: '$1.9M',
  goal: '92%',
  pipeline: '$2.2M',
  calls: 35,
  status: 'watch'
}, {
  id: 4,
  name: 'Jessica Wong',
  tier: 'B',
  funded: '$1.7M',
  goal: '88%',
  pipeline: '$2.5M',
  calls: 41,
  status: 'watch'
}, {
  id: 5,
  name: 'Robert Wilson',
  tier: 'C',
  funded: '$850k',
  goal: '45%',
  pipeline: '$1.1M',
  calls: 18,
  status: 'critical'
}, {
  id: 6,
  name: 'Amanda Johnson',
  tier: 'B',
  funded: '$1.5M',
  goal: '82%',
  pipeline: '$2.1M',
  calls: 38,
  status: 'watch'
}, {
  id: 7,
  name: 'James Smith',
  tier: 'C',
  funded: '$620k',
  goal: '38%',
  pipeline: '$900k',
  calls: 15,
  status: 'critical'
}];
export function LOBreakdownTable() {
  return <div className="bg-slate-800 border border-slate-700 rounded-lg overflow-hidden" data-id="element-20">
      <div className="p-6 border-b border-slate-700 flex justify-between items-center" data-id="element-21">
        <h3 className="text-lg font-semibold text-white" data-id="element-22">
          Loan Officer Breakdown
        </h3>
        <button className="text-sm text-blue-400 hover:text-blue-300 font-medium" data-id="element-23">
          View Full Report
        </button>
      </div>

      <div className="overflow-x-auto" data-id="element-24">
        <table className="w-full text-left border-collapse" data-id="element-25">
          <thead data-id="element-26">
            <tr className="bg-slate-900/50 text-slate-400 text-xs uppercase tracking-wider" data-id="element-27">
              <th className="p-4 font-medium" data-id="element-28">Loan Officer</th>
              <th className="p-4 font-medium" data-id="element-29">Tier</th>
              <th className="p-4 font-medium text-right" data-id="element-30">Funded Vol (MTD)</th>
              <th className="p-4 font-medium text-right" data-id="element-31">% to Goal</th>
              <th className="p-4 font-medium text-right" data-id="element-32">Pipeline</th>
              <th className="p-4 font-medium text-right" data-id="element-33">Avg Calls/Day</th>
              <th className="p-4 font-medium text-center" data-id="element-34">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-700" data-id="element-35">
            {loData.map(lo => <tr key={lo.id} className="hover:bg-slate-700/30 transition-colors" data-id="element-36">
                <td className="p-4" data-id="element-37">
                  <div className="font-medium text-white" data-id="element-38">{lo.name}</div>
                </td>
                <td className="p-4" data-id="element-39">
                  <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${lo.tier === 'A' ? 'bg-emerald-500/10 text-emerald-400' : lo.tier === 'B' ? 'bg-blue-500/10 text-blue-400' : 'bg-amber-500/10 text-amber-400'}`} data-id="element-40">
                    Tier {lo.tier}
                  </span>
                </td>
                <td className="p-4 text-right font-mono text-slate-200" data-id="element-41">
                  {lo.funded}
                </td>
                <td className="p-4 text-right" data-id="element-42">
                  <div className="flex items-center justify-end gap-1" data-id="element-43">
                    <span className={parseInt(lo.goal) >= 100 ? 'text-emerald-400' : 'text-slate-300'} data-id="element-44">
                      {lo.goal}
                    </span>
                    {parseInt(lo.goal) >= 100 ? <ArrowUpRightIcon className="w-3 h-3 text-emerald-400" data-id="element-45" /> : <ArrowDownRightIcon className="w-3 h-3 text-slate-500" data-id="element-46" />}
                  </div>
                </td>
                <td className="p-4 text-right font-mono text-slate-300" data-id="element-47">
                  {lo.pipeline}
                </td>
                <td className="p-4 text-right text-slate-300" data-id="element-48">{lo.calls}</td>
                <td className="p-4 text-center" data-id="element-49">
                  <div className={`w-2 h-2 rounded-full mx-auto ${lo.status === 'healthy' ? 'bg-emerald-500 shadow-[0_0_8px_rgba(16,185,129,0.5)]' : lo.status === 'watch' ? 'bg-amber-500 shadow-[0_0_8px_rgba(245,158,11,0.5)]' : 'bg-rose-500 shadow-[0_0_8px_rgba(244,63,94,0.5)]'}`} data-id="element-50" />
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}